// 美元汇率
const RMB_TO_USD = 6.8;

// 价格表: 人民币/秒
// 0.441945 人民币
export const rmbCost480p = (854 * 480 * 24 / 1024 / 1000000 * 46);
export const usdCost480p = rmbCost480p / RMB_TO_USD;
// 0.9939 人民币
export const rmbCost720p = (1280 * 720 * 24 / 1024 / 1000000 * 46);
export const usdCost720p = rmbCost720p / RMB_TO_USD;
// 2.4786 人民币
export const rmbCost1080p = (1920 * 1080 * 24 / 1024 / 1000000 * 51);
export const usdCost1080p = rmbCost1080p / RMB_TO_USD;
// 5.0544 人民币
export const rmbCost4k = (3840 * 2160 * 24 / 1024 / 1000000 * 26);
export const usdCost4k = rmbCost4k / RMB_TO_USD;
// 0.26901 人民币
export const rmbRefCost480p = (854 * 480 * 24 / 1024 / 1000000 * 28);
export const usdRefCost480p = rmbRefCost480p / RMB_TO_USD;
// 0.6048 人民币
export const rmbRefCost720p = (1280 * 720 * 24 / 1024 / 1000000 * 28);
export const usdRefCost720p = rmbRefCost720p / RMB_TO_USD;
// 1.5066 人民币
export const rmbRefCost1080p = (1920 * 1080 * 24 / 1024 / 1000000 * 31);
export const usdRefCost1080p = rmbRefCost1080p / RMB_TO_USD;
// 3.1104 人民币
export const rmbRefCost4k = (3840 * 2160 * 24 / 1024 / 1000000 * 16);
export const usdRefCost4k = rmbRefCost4k / RMB_TO_USD;
// Fast
// 0.3554775 人民币
export const rmbCost480pFast = (854 * 480 * 24 / 1024 / 1000000 * 37);
export const usdCost480pFast = rmbCost480pFast / RMB_TO_USD;
// 0.7992 人民币
export const rmbCost720pFast = (1280 * 720 * 24 / 1024 / 1000000 * 37);
export const usdCost720pFast = rmbCost720pFast / RMB_TO_USD;
// 0.211365 人民币
export const rmbRefCost480pFast = (854 * 480 * 24 / 1024 / 1000000 * 22);
export const usdRefCost480pFast = rmbRefCost480pFast / RMB_TO_USD;
// 0.4752 人民币
export const rmbRefCost720pFast = (1280 * 720 * 24 / 1024 / 1000000 * 22);
export const usdRefCost720pFast = rmbRefCost720pFast / RMB_TO_USD;
// Mini
// 0.2209725 人民币
export const rmbCost480pMini = (854 * 480 * 24 / 1024 / 1000000 * 23);
export const usdCost480pMini = rmbCost480pMini / RMB_TO_USD;
// 0.4968 人民币
export const rmbCost720pMini = (1280 * 720 * 24 / 1024 / 1000000 * 23);
export const usdCost720pMini = rmbCost720pMini / RMB_TO_USD;
// 0.134505 人民币
export const rmbRefCost480pMini = (854 * 480 * 24 / 1024 / 1000000 * 14);
export const usdRefCost480pMini = rmbRefCost480pMini / RMB_TO_USD;
// 0.3024 人民币
export const rmbRefCost720pMini = (1280 * 720 * 24 / 1024 / 1000000 * 14);
export const usdRefCost720pMini = rmbRefCost720pMini / RMB_TO_USD;